<div #cont [style.max-height]="styleMaxHeight" [style.cursor]="styleCursor" [style.overflow]="styleOverflow" (click)="containerClicked();">
	<ng-content></ng-content>
</div>
<div *ngIf="overflows && !opened" class="showMore" (click)="containerClicked();">
	<div class="blur-area"></div>
	<div class="text-area">{{ 'SHOW_MORE' | translate }}</div>
</div>
